"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../../../../material/index");

var _index2 = require("../../../../utils/index");

var _index3 = require("../../../../utils/styles/index");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _column_styles = _interopRequireDefault(require("../../../../material/tables/listtable/column/column_styles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// material
// utils
// styles

/* ========== ~~~~~~~~~~ EXPORT : TABLE : COLUMN ~~~~~~~~~~ ========== */


var _default = (0, _reactJss.default)(_column_styles.default)(function (props) {
  var fixedColWidth = {
    width: "".concat((0, _index3.pxToEm)(props.fixedColWidth))
  };
  var fixedColWidthPadding = {
    width: "".concat((0, _index3.pxToEm)(props.fixedColWidth))
  };

  var fixedCol = function fixedCol() {
    return _react.default.createElement("span", {
      className: "grouper",
      style: fixedColWidthPadding
    }, _react.default.createElement("td", {
      className: "column ".concat((0, _index2.generateClasses)(props), " ").concat(props.classes.column),
      style: fixedColWidth,
      colSpan: props.colspan,
      "data-attr": props.addDataAttribute ? props.children : null
    }, _react.default.createElement("div", {
      className: "sizer",
      style: fixedColWidth
    }), _react.default.createElement(_index.Ellipsis, {
      tooltip: "right"
    }, props.children)), _react.default.createElement("td", {
      className: "spacer"
    }, _react.default.createElement("div", {
      className: "sizer",
      style: fixedColWidthPadding
    })));
  };

  var standardCol = function standardCol() {
    return _react.default.createElement("td", {
      className: "column ".concat((0, _index2.generateClasses)(props), " ").concat(props.classes.column),
      colSpan: props.colspan,
      "data-attr": props.addDataAttribute ? props.children : null
    }, props.children);
  };

  return props.isFixedCol ? fixedCol() : standardCol();
});

exports.default = _default;